var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4938 7.10156C14.4938 7.10156 14.0866 12.1528 13.8503 14.2806C13.7378 15.2968 13.1101 15.8923 12.0818 15.9111C10.1251 15.9463 8.16609 15.9486 6.21009 15.9073C5.22084 15.8871 4.60359 15.2841 4.49334 14.2858C4.25559 12.1393 3.85059 7.10156 3.85059 7.10156",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.531 4.68066H2.8125",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0799 4.68023C12.4912 4.68023 11.9842 4.26398 11.8687 3.68723L11.6864 2.77523C11.5739 2.35448 11.1929 2.06348 10.7587 2.06348H7.58395C7.1497 2.06348 6.7687 2.35448 6.6562 2.77523L6.47395 3.68723C6.35845 4.26398 5.85145 4.68023 5.2627 4.68023",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.731e3589c51c1c3dd3e7ede9b9dcc7e9.svg";
export { ForwardRef as ReactComponent };